export default __webpack_public_path__ + "static/media/five.82d3772c.png";